let assistanceTypes = [
  { value: "BIPPER", label: "Bipper" },
  {
    value: "ANTI_INTRUSION_ALARM",
    label: "Alarme Anti Intrusion",
  },
  { value: "CAMERA", label: "Camera" },
  { value: "OTHER", label: "Autre" },
];

export default assistanceTypes;
